import { DialogWrapable } from '../dialog/dialog_wrapper';
import DialogWrapper from '../dialog/dialog_wrapper';
import * as React from 'react';

interface FileUploadDialogProps extends React.ClassAttributes<any> {
    getRef?(ref: any): void;
    isHidden?: boolean;
    onDataLoaded(data: any): void;
    onDataSelected?(): void;
}

interface FileUploadDialogState {
    dialogWrapper?: DialogWrapper;
}

export class FileUploadDialog extends React.Component<FileUploadDialogProps, FileUploadDialogState> implements DialogWrapable {

    constructor(props: any) {
        super(props);
        this.setDialogWrapper = this.setDialogWrapper.bind(this);
        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.state = {
            dialogWrapper: undefined
        };
    }

    handleChangeFile(file: any): void {
        const reader = new FileReader();
        const that = this;

        if (this.props.onDataSelected) {
            this.props.onDataSelected();
        }
        reader.onload = function (event: any) {
            // console.log(event.target.result);
            that.props.onDataLoaded(event.target.result);
            /*if (that.state.dialogWrapper) {
              that.state.dialogWrapper.closeDialog();
            }*/
        };

        if (typeof reader.readAsBinaryString === 'function') {
            reader.readAsBinaryString(file);
        } else {
            // IE11 Lösung
            const blobURL = URL.createObjectURL(file);
            const xhr = new XMLHttpRequest;
            xhr.open('get', blobURL);
            xhr.overrideMimeType('text/plain; charset=x-user-defined');
            xhr.onload = function () {
                const binary = xhr.response;
                that.props.onDataLoaded(binary);
            };
            xhr.send();
        }
    }

    render(): JSX.Element {
        return (
            <div style={ this.props.isHidden ? { display: 'none' } : {} }>
                <input
                    ref={this.props.getRef}
                    type='file'
                    onChange={(event: any) => this.handleChangeFile(event.target.files[0])}
                />
            </div>
        );
    }

    setDialogWrapper(dialogWrapper: DialogWrapper): void {
        // this.setState({dialogWrapper});
    }
}
